/*
 * Copyright © 2017 - 2019 Atilika Inc. All rights reserved.
 */

import clsx from "clsx";
import React, {ReactNode} from "react";
import {createUseStyles} from "react-jss";
import UI from "../UI";

const useStyles = createUseStyles({
    root: {
        marginBottom: "2rem",
        "&:last-child": {
            marginBottom: 0
        }
    },
    small: {
        "& p": {
            fontSize: "1.125rem",
            lineHeight: 1.5,
            "&:lang(ja)": {
                fontSize: "1rem"
            },
            [UI.media.gte("sm")]: {
                letterSpacing: ".025rem",
                lineHeight: 1.6,
                fontSize: "1.25rem",
                fontWeight: 400,
                "&:lang(ja)": {
                    fontSize: "1rem"
                }
            },
            [UI.media.gte("md")]: {
                letterSpacing: ".03125rem",
                lineHeight: 1.75,
                fontSize: "1.375rem",
                "&:lang(ja)": {
                    fontSize: "1.25rem"
                }
            }
        }
    },
    large: {
        "& p": {
            fontSize: "1.5rem",
            fontWeight: 400,
            lineHeight: 1.8,
            "&:lang(ja)": {
                fontSize: "1.25rem"
            },
            [UI.media.only("xs")]: {
                fontSize: "1.5rem",
                lineHeight: 1.5,
                "&:lang(ja)": {
                    fontSize: "1.25rem"
                }
            }
        }
    }
});

interface LeadProps {
    size: "small" | "large";
    children: ReactNode;
}

export function Lead({size, children}: LeadProps) {
    const classes = useStyles();
    const className = clsx(classes.root, {
        [classes.small]: size === "small",
        [classes.large]: size === "large"
    });
    return <div className={className}>{children}</div>;
}
